<!-- 教育局-交易记录 -->
<template>
  <div>
    <div class="index" v-if="!detail.show && !addShow && !employeesShow">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
        <!-- <p style="color:#606266;font-size:14px;">样例</p> -->
      </div>
      <div>
        <el-form :model="queryParams" label-width="70px">
          <!-- <el-form-item label="所在区域">
            <el-select
              style="margin-right: 10px"
              v-model="queryParams.address.proviceCode"
              @change="handleProviceChange"
              clearable
              filterable
              placeholder="请选择省"
            >
              <el-option
                v-for="item in proviceList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-select
              style="margin-right: 10px"
              v-model="queryParams.address.cityCode"
              @change="handleCityChange"
              clearable
              filterable
              placeholder="请选择市"
            >
              <el-option
                v-for="item in cityList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryParams.address.areaCode"
              @change="handleAreaChange"
              clearable
              filterable
              placeholder="请选择区"
            >
              <el-option
                v-for="item in areaList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="培训机构">
            <el-col :span="5">
              <el-form-item label="">
                <el-input placeholder="请输入" v-model="queryParams.a">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="订单编号" >
                <el-input placeholder="请输入" v-model="queryParams.b">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="交易流水号" label-width="100px">
                <el-input placeholder="请输入" v-model="queryParams.c">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="订单时间">
             <el-col :span="5">
               <el-date-picker
                style="width:300px"
                v-model="queryParams.data"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
            <el-col :span="2" style="margin-left:5%">
              <el-form-item label="" label-width="100px">
                  <el-button type="primary" size="small" @click="searchFun()"
                      >查询</el-button
                    >
              </el-form-item>
            </el-col>
          </el-form-item> -->
        </el-form>
        <div class="totalData">
           <div class="totalItime">
               <p class="totalItime_top">￥{{educationType?112456:681721}} </p>
               <p class="totalItime_bottom">课程订单总金额(元)</p>
           </div>
            <div class="totalItime">
               <p class="totalItime_top">￥{{educationType?36543:91721}}</p>
               <p class="totalItime_bottom">材料订单总金额(元)</p>
           </div>
            <div class="totalItime">
               <p class="totalItime_top">￥{{educationType?8221:10291}} </p>
               <p class="totalItime_bottom">退费总金额(元)</p>
           </div>
            <div class="totalItime">
               <p class="totalItime_top">￥{{educationType? 72931:392101}} </p>
               <p class="totalItime_bottom">保证金转出(元)</p>
           </div>
        </div>
        <!-- 待审核 -->
        <div class="table">
          <el-table :data="tableData" style="width: 100%" tooltip-effect="dark">
            <el-table-column prop="a" label="培训机构" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="b" label="订单编号" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="c" label="交易流水号" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="d" label="交易类型" align="center"></el-table-column>
            <!-- <el-table-column v-if="!educationType" prop="e" label="区域" show-overflow-tooltip align="center">
            </el-table-column> -->
            <el-table-column prop="f" label="交易金额(元)" show-overflow-tooltip width="120px" align="center">
            </el-table-column>
            <el-table-column prop="g" label="交易时间" show-overflow-tooltip align="center">
            </el-table-column>
            <!-- <el-table-column  header-align="center" width="70" label="操作" align="center">
                  <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看</el-button>
                  </template>
            </el-table-column> -->
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="page.pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="page.pageSize"
              :total="page.totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getOrgList,
  createOrg,
  getNextAreaInfo,
  getQYInfo,
  getOrgQYList,
} from "@/api/user/userCenter";
export default {
  components: {},
  data() {
    return {
      educationType:sessionStorage.getItem('educationType')==='area',
      queryParams: {
        a: "",
        b: "",
        c: "",
        address: {
          proviceCode: "",
          proviceName: "",
          cityCode: "",
          cityName: "",
          areaCode: "",
          areaName: "",
        }, //覆盖区域控件选择的地址(默认值)
         data: '',
      },
      proviceList: [], //省列表数据
      cityList: [], //市列表数据
      areaList: [], //区列表数据
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 10,
      },
      addShow: false,
      employeesShow: false,
      detail: {
        info: {},
        show: false,
      },
      statusList: [
        { id: "0", label: "未激活" },
        { id: "1", label: "正常" },
      ],
      recordStatusList: [
        { id: "0", label: "未备案" },
        { id: "1", label: "已备案" },
      ],
      tableData:[],
      visible: false,
      selectOrgId: "",
    };
  },
  watch: {},
  mounted() {},
  created() {
    this.getDataList();
    this.initData();
  },
  filters: {
    statusFilter(type) {
      const typeMap = {
        0: "未激活   ",
        1: "正常    ",
        2: "注销    ",
        3: "锁定    ",
        4: "安管锁定",
        5: "空间封锁",
      };
      return typeMap[type];
    },
    recordStatusFilter(type) {
      const typeMap = {
        0: "未备案",
        1: "已备案",
      };
      return typeMap[type];
    },
  },
  methods: {
    async initData() {
      // 用户中心获取全部省的数据
      getNextAreaInfo({ area_code: "0" }).then((res) => {
        if (res.code == "000000") {
          this.proviceList = res.result;
        }
      });
      if(this.educationType){
        if(sessionStorage.getItem('platformCode')=='460000'){
            this.tableData=[
           {a:'智课 ',    b:'D32434221353224',c:'1777608446799373',d:'退费           ',  e:' 秀英区',f:' -880',  g:' 2022/2/26 9:23'},
           {a:'欧美思',   b:'D92817382938182',c:'1829992372909996',d:'保证金转出（元）',  e:'龙华区 ',f:'-1512 ', g:'2022/2/26 8:58 '},
           {a:'第七感官', b:'D28173829101022',c:'1777608446799373',d:'保证金转出（元）',  e:'琼山区 ',f:'-12070 ', g:'2022/2/24 19:18 '},
           {a:'黑色空间', b:'D32434221353224',c:'2738193899218281',d:'预收费         ',  e:' 美兰区',f:' 13960 ', g:' 2022/2/23 8:58'},
         ]
        }else{
           this.tableData=[
           {a:'智课 ',    b:'D32434221353224',c:'1777608446799373',d:'退费           ',  e:' 武昌区',f:' -880',  g:' 2022/2/26 9:23'},
           {a:'欧美思',   b:'D92817382938182',c:'1829992372909996',d:'保证金转出（元）',  e:'汉阳区 ',f:'-1512 ', g:'2022/2/26 8:58 '},
           {a:'第七感官', b:'D28173829101022',c:'1777608446799373',d:'保证金转出（元）',  e:'硚口区 ',f:'-12070 ', g:'2022/2/24 19:18 '},
           {a:'黑色空间', b:'D32434221353224',c:'2738193899218281',d:'预收费         ',  e:' 江岸区',f:' 13960 ', g:' 2022/2/23 8:58'},
           {a:'小鱼',     b:'D92817382938182',c:'8382920193839392',d:'预收费         ',  e:' 江汉区',f:' 5480 ',  g:' 2022/2/21 10:23'},
           {a:'许先望',   b:'D28173829101022',c:'5948718103847294',d:'退费           ',  e:' 青山区',f:' -2911 ', g:' 2022/2/20 7:52'},
           {a:'果力教育', b:'D32434221353224',c:'9183739210303213',d:'保证金转出（元）',  e:'江夏区 ',f:'-1321  ', g:'2022/2/14 16:23 '},
           {a:'智位科技', b:'D92817382938182',c:'9582819847327122',d:'保证金转出（元）',  e:'武昌区 ',f:'-653  ',  g:'2022/2/13 9:28 '},
           {a:'海鸟信息', b:'D28173829101022',c:'1359204818392910',d:'预收费          ', e:'武昌区 ',f:'4370 ',   g:'2022/2/6 11:33 '},
           {a:'博客音乐', b:'D32434221353224',c:'9837828299010211',d:'预收费          ', e:'洪山区 ',f:'3960 ',   g:'2022/2/6 12:58 '},           
         ]
        }
         
      }else{
        if(sessionStorage.getItem('platformCode')=='460000'){
            this.tableData=[
           {a:'昂立教育有限责任公司',    b:'D88434107303964',c:'1829992372909996',d:'退费',             e:' 秀英区',f:' -880 ', g:' 2022/2/26 9:23'},
           {a:'嘉瑞新创教育咨询有限公司',b:'D71749382912622',c:'1777608446799373',d:'保证金转出（元）',  e:'龙华区 ',f:'-1512 ', g:'2022/2/26 8:58 '},
           {a:'云上美术培训学校有限公司',    b:'D55064658521280',c:'1829992372909996',d:'保证金转出（元）',  e:'琼山区 ',f:'-12070 ',g:'2022/2/24 19:18 '},
           {a:'华瑞教育培训学校有限公司',    b:'D38379934129938',c:'1777608446799373',d:'预收费',           e:' 美兰区',f:' 13960', g:' 2022/2/23 8:58'},
         ]
        }else{
           this.tableData=[
           {a:'青苗教育培训学校有限公司',    b:'D88434107303964',c:'1829992372909996',d:'退费',             e:' 武昌区',f:' -880 ', g:' 2022/2/26 9:23'},
           {a:'睿智明德教育培训学校有限公司',b:'D71749382912622',c:'1777608446799373',d:'保证金转出（元）',  e:'汉阳区 ',f:'-1512 ', g:'2022/2/26 8:58 '},
           {a:'云上美术培训学校有限公司',    b:'D55064658521280',c:'1829992372909996',d:'保证金转出（元）',  e:'硚口区 ',f:'-12070 ',g:'2022/2/24 19:18 '},
           {a:'华瑞教育培训学校有限公司',    b:'D38379934129938',c:'1777608446799373',d:'预收费',           e:' 江岸区',f:' 13960', g:' 2022/2/23 8:58'},
           {a:'六一信息科技有限公司',        b:'D21695209738596',c:'1829992372909996',d:'预收费',           e:' 江汉区',f:' 5480',  g:' 2022/2/21 10:23'},
           {a:'敏学信息科技有限公司',        b:'D05010485347254',c:'1777608446799373',d:'退费',             e:' 青山区',f:' -2911', g:' 2022/2/20 7:52'},
           {a:'昂立教育有限责任公司',        b:'D11674239044088',c:'1829992372909996',d:'保证金转出（元）',  e:'江夏区 ',f:'-1321 ', g:'2022/2/14 16:23 '},
           {a:'环纳教育科技有限公司',        b:'D28358963435430',c:'1777608446799373',d:'保证金转出（元）',  e:'武昌区 ',f:'-653 ',  g:'2022/2/13 9:28 '},
           {a:'嘉瑞新创教育咨询有限公司',    b:'D45043687826772',c:'1829992372909996',d:'预收费',            e:'武昌区 ',f:'4370 ',  g:'2022/2/6 11:33 '},
           {a:'三好互动教育科技有限公司',    b:'D61728412218114',c:'1777608446799373',d:'预收费',            e:'洪山区 ',f:'3960 ',  g:'2022/2/6 12:58 '},           
         ]
        }
        
      }
    },

    async getDataList() {
      console.log("调用机构列表2");
      let isPlatform=(JSON.parse(window.sessionStorage.getItem("userInfo")).v_platform_code===JSON.parse(window.sessionStorage.getItem("userInfo")).platform_code || JSON.parse(window.sessionStorage.getItem("userInfo")).v_platform_code.includes(","))
      let params = {
        // org_id:sessionStorage.getItem("orgId")||'', //	机构、学校等组织id
        org_name: this.queryParams.org_name, //	机构、学校等组织名称
        org_type: "8", //	组织类型，多个使用英文逗号分隔(1机构，2学校，8企业，9教学工作室，10平台)
        province_code: "", //	所属地理省份
        city_code: "", //	所属地理市
        area_code: "", //	所属地理区
        status: this.queryParams.status, //       	状态,多个使用英文逗号分隔(0:组织未激活,1:正常)
        platform_code:isPlatform?sessionStorage.getItem("platformCode"):'', //	实体平台编码
        v_platform_code: isPlatform?'':JSON.parse(window.sessionStorage.getItem("userInfo")).v_platform_code, //	虚拟平台编码
        certification: "", //	认证(0:未认证,1:已认证)
        org_category: "2", //	组织的类别(见文档十三.4，每个类型的组织都有自己的类别)
        org_level_code: "", //	行政区划(行政上所属的区域)
        org_parent_id: "", //	上级机构id(查的是直属下级单位)
        org_parent_ids: sessionStorage.getItem("orgid_top")||'', //	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
        flag: "", //	         标记,多个使用英文逗号分隔,默认正常和演示(0:正常,1:演示,2:测试)
        page: this.page.pageNum, //	查询页单独的对的
        page_size: this.page.pageSize, //	查询条数，默认10，上限10011
        is_more: "1", //	返回更多信息(0:否,1:是)
        org_record_status: this.queryParams.org_record_status, // 教育局备案状态
        more_field: [
          "org_record_status",
          "school_legal_person_name",
          "school_legal_person_code",
          "org_code_certificate",
          "org_address",
          "org_telephone",
          "org_social_credit_code",
          "status",
          "org_source_level",
          "org_resource_id",
        ], //	指定返回的字段名称,传入看示例
        sort: "time", //按时间排序
      };
      var { code, result } = await getOrgList(params);
      if (code === "000000") {
        2;
        // this.tableData = result.lists;
        // this.page.totalPage = result.count;
         this.page.totalPage = this.tableData.length;
      }
      console.log("机构-列表77", result);
    },
    async handleProviceChange(areaCode) {
      var obj = {};
      obj = this.proviceList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.proviceName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.cityList = result;
      }
      this.queryParams.address.cityCode = "";
      this.queryParams.address.cityName = "";
      this.queryParams.address.areaCode = "";
      this.queryParams.address.areaName = "";
    },
    async handleCityChange(areaCode) {
      var obj = {};
      obj = this.cityList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.cityName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.areaList = result;
      }
      this.queryParams.address.areaCode = "";
      this.queryParams.address.areaName = "";
    },
    async handleAreaChange(areaCode) {
      var obj = {};
      obj = this.areaList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.areaName = obj.area_name;
    },
    searchFun() {
      let searchList=[]
      let _queryParams =this.queryParams
      this.tableData.forEach(it=>{
         console.log('----------',it.a,_queryParams.a);
        if(it.a == _queryParams.a || it.b == _queryParams.b || it.c == _queryParams.c){
          console.log('888888888',it);
           searchList.push(it)
        }
      })
      this.tableData=searchList
      // this.page.pageNum = 1;
      // this.getDataList();
    },
    add() {
      this.addShow = true;
    },
    sizeChangeHandle(val) {
      // let that;
      // if(this.tabName==='待审核'){
      // 	that=this.queryParams;
      // }else if(this.tabName==='审核通过'){
      // 	that=this.queryParams_2;
      // }else{
      // 	that=this.queryParams_3;
      // }

      this.page.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      console.log("点击查看机构详情----", item);
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      console.log("调用机构列表1");
      this.detail.show = false;
      this.addShow = false;
      this.employeesShow = false;
      this.page.pageNum = 1;
      this.getDataList();
    },
    pass(id) {},
    reject(id) {
      this.selectOrgId = id;
      this.employeesShow = true;
    },
    //  locking (id) {
    // 	let params = {
    //     usession_id: sessionStorage.getItem("usessionid"), //	否	string	学年学期
    //     user_id:userId,
    //     status:'3',//0:未激活, 1:正常, 2:注销, 3:成员锁定, 4:安管锁定,5:空间封锁）
    //   };
    // //   var { code, message } = await setUserStatus(params);
    //   if (code == "000000") {
    //      this.page.pageNum=1
    //      this.getDataList()
    //      this.$message({
    //       type: "success",
    //       message: "操作成功",
    //     });
    //   }else{
    //     this.$message({
    //       type: "error",
    //       message: message,
    //     });
    //   }
    //  },
    tabClick(item) {
      this.tabName = item.name;
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }
  .totalData{
       width: 100%;
      margin: 20px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      .totalItime{
        width: 30%;
        height: 100px;
        margin-right: 20px;
        background-color: #F5FAFF;
         border-radius: 6px;
         text-align: center;
        .totalItime_top{
          padding: 14px 0 7px;
          font-size: 32px;
          color: #4991E1;
          font-weight: bold;
          line-height: 42px;
        }
        .totalItime_bottom{
          font-size: 18px;
          color: #555555;
        }
      }
  }
  ::v-deep .el-form .el-input__inner {
    width: 170px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }
  // ::v-deep .el-form-item__content{
  //     margin-left: -10px !important;
  // }
  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.confirm {
  .content {
    width: 100%;
    padding: 0 15px 15px;
    text-align: center;
  }
}
</style>
